module.exports = __webpack_public_path__ + "img/gb1235-76-35.prt.3d6c4cc6.jpg";